export const CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION_FEEDBACK = 'CANCEL_SUBSCRIPTION_FEEDBACK';
export const CANCEL_SUBSCRIPTION_CONFIRMATION = 'CANCEL_SUBSCRIPTION_CONFIRMATION';
export const INVOICES = 'INVOICES';
export const INVOICE_DETAILS = 'INVOICE_DETAILS';
export const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';
/* PLOP_INJECT_MODAL_TYPE */

export const cancellationFlowModals = [
    CANCEL_SUBSCRIPTION,
    CANCEL_SUBSCRIPTION_FEEDBACK,
    CANCEL_SUBSCRIPTION_CONFIRMATION,
];

export const invoiceModals = [
    INVOICES,
    INVOICE_DETAILS,
];

export const genericModals = [
    CONFIRMATION_MODAL,
];
